export const processHeading = 'Our Process';

export const processQuestions = [
  'Should we enter this market?',
  'Who will pay?',
  'What should we charge?',
  'Why isn’t this growing?',
];

export const processFollowUp = 'We start by working alongside founders and their teams on questions like these.';

export const processSteps = [
  {
    n: '01',
    title: 'Frame.',
    lead: 'Find the problem underneath the problem.',
    body: 'We talk to customers, examine the economics, and test the assumptions behind the question.',
  },
  {
    n: '02',
    title: 'Decide.',
    lead: 'Work out what the evidence supports, commit to a direction.',
    body: 'We test demand, compare what each path would net using prototypes and commercial judgment.',
  },
  {
    n: '03',
    title: 'Build.',
    lead: 'Put decisions into practice.',
    body: 'We build go-to-market, pricing, and revenue operations systems, implementing AI where it materially improves the outcome.',
  },
  {
    n: '04',
    title: 'Scale.',
    lead: 'Make the work part of how the business runs.',
    body: 'We partner with Product, Finance, Marketing, Engineering and Sales to set operating rhythms that keep systems improving as the company grows.',
  },
];

/** One sentence, set as three descending clauses: top, middle, ground. */
export const processClosing = [
  'We report to the top,',
  'lead across functions in the middle,',
  'and stay close to execution on the ground.',
];
